import * as React from 'react';

import {
    BaseInventoryContract,
    CharacterTheme,
    Constants,
    DataOrigin,
    EntityUtils,
} from '@dndbeyond/character-rules-engine/es';

import { BaseInventoryName } from '../ItemName';

interface Props {
    dataOrigin: DataOrigin;
    onClick?: (dataOrigin: DataOrigin) => void;
    className: string;
    theme: CharacterTheme;
}

export default class DataOriginName extends React.PureComponent<Props> {
    static defaultProps = {
        className: '',
    };

    handleClick = (evt: React.MouseEvent): void => {
        const { onClick, dataOrigin } = this.props;

        if (onClick) {
            evt.stopPropagation();
            evt.nativeEvent.stopImmediatePropagation();
            onClick(dataOrigin);
        }
    };

    render() {
        const { dataOrigin, className, theme } = this.props;

        let displayNode: React.ReactNode;

        switch (dataOrigin.type) {
            case Constants.DataOriginTypeEnum.ITEM:
                displayNode = <BaseInventoryName item={dataOrigin.primary as BaseInventoryContract} theme={theme} />;
                break;

            default:
                displayNode = EntityUtils.getDataOriginName(dataOrigin);
        }

        let classNames: Array<string> = [className, 'ddbc-data-origin-name'];

        return (
            <span className={classNames.join(' ')} onClick={this.handleClick}>
                {displayNode}
            </span>
        );
    }
}
